import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Eye, EyeOff } from 'lucide-react';

const LOGO_URL = "/images/wayside-logo-horizontal.png";

const AdminLoginPage = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const { login } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setIsLoading(true);

        try {
            await login(username, password);
            navigate('/admin/dashboard');
        } catch (err) {
            setError('Invalid credentials');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-maple-dark flex items-center justify-center px-6" data-testid="admin-login-page">
            <div className="w-full max-w-md">
                <div className="text-center mb-12">
                    <img 
                        src={LOGO_URL} 
                        alt="Wayside Maple" 
                        className="h-12 w-auto mx-auto brightness-0 invert mb-8"
                    />
                    <h1 className="font-anton text-3xl text-white">ADMIN LOGIN</h1>
                </div>

                <div className="bg-maple-card border border-white/10 p-8 md:p-10">
                    {error && (
                        <div className="bg-red-900/30 border border-red-500/30 text-red-400 p-4 mb-6" data-testid="login-error">
                            {error}
                        </div>
                    )}

                    <form onSubmit={handleSubmit} className="space-y-6" data-testid="admin-login-form">
                        <div>
                            <label className="block text-white/40 text-sm uppercase tracking-wider mb-2">
                                Username
                            </label>
                            <input
                                type="text"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                required
                                className="w-full"
                                placeholder="Enter username"
                                data-testid="login-username"
                            />
                        </div>

                        <div>
                            <label className="block text-white/40 text-sm uppercase tracking-wider mb-2">
                                Password
                            </label>
                            <div className="relative">
                                <input
                                    type={showPassword ? 'text' : 'password'}
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                    className="w-full pr-12"
                                    placeholder="Enter password"
                                    data-testid="login-password"
                                />
                                <button
                                    type="button"
                                    onClick={() => setShowPassword(!showPassword)}
                                    className="absolute right-0 top-1/2 -translate-y-1/2 p-3 text-white/40 hover:text-white transition-colors"
                                >
                                    {showPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
                                </button>
                            </div>
                        </div>

                        <button
                            type="submit"
                            disabled={isLoading}
                            className="btn-primary w-full disabled:opacity-50"
                            data-testid="login-submit"
                        >
                            <span>{isLoading ? 'Signing in...' : 'Sign In'}</span>
                        </button>
                    </form>
                </div>

                <p className="text-center text-white/40 text-sm mt-8">
                    <a href="/" className="hover:text-white transition-colors">
                        ← Back to Store
                    </a>
                </p>
            </div>
        </div>
    );
};

export default AdminLoginPage;
